import { AuthenticationState } from "../reducer/state";
import { useAppState } from "../../appState";

export default function useAuthenticationState(): AuthenticationState {
	return useAppState().authentication;
}
